<mbs-modal
  [title]="getModalTitle()"
  [attr.data-e2e]="'add-destination-modal'"
  [isCustomModal]="true"
  [loading]="loading"
  #modal>
  <ng-container modal-body>
    <mbs-alert
      *ngIf="errorText"
      [type]="popupType.danger"
      [icon]="true">
      {{ errorText }}
    </mbs-alert>

    <ng-container *ngIf="destination && !hasCriticalError">
      <mbs-alert
        [type]="popupType.warning"
        [icon]="true">
        @if (destination?.isReadOnly) {
          {{ 'shared:modals.addDestinationBucket.insufficientPermissionsToEditDestination' | i18next: { type: bucketTypeName } }}
        } @else {
          <ul>
            <li>{{ 'shared:modals.addDestinationBucket.changedBucketWarningAgent' | i18next: { type: bucketTypeName } }}</li>
            <li [innerHTML]="'shared:modals.addDestinationBucket.changedBucketWarningOffice' | i18next: { type: bucketTypeName }"></li>
          </ul>
        }
      </mbs-alert>
    </ng-container>

    <ng-container *ngIf="!createNew?.value && currentBucket?.warnings?.length">
      <mbs-alert
        [type]="popupType.warning"
        [icon]="true">
        <ng-container *ngIf="currentBucket.warnings?.length === 1; else list">
          {{ currentBucket?.warnings?.[0] }}
        </ng-container>

        <ng-template #list>
          <ul class="mb-0 p-0 ml-4">
            <li *ngFor="let warning of currentBucket.warnings">{{ warning }}</li>
          </ul>
        </ng-template>
      </mbs-alert>
    </ng-container>

    <ng-container *ngIf="!deprecatedStorageTypes.includes(storageAccount.storageType); else deprecatedStorageTemplate">
      <mbs-add-destination-form
        [form]="form"
        [createNew]="createNew"
        [destination]="destination"
        [bucketTypeName]="bucketTypeName"
        [storageAccount]="storageAccount"
        (formUnstable)="innerLoading = $event"
        (initialLoading)="loading = $event"
        (criticalError)="onCriticalError($event)"
        (currentBucketChanged)="currentBucket = $event">
      </mbs-add-destination-form>
    </ng-container>

    <ng-template #deprecatedStorageTemplate>
      {{ 'shared:modals.unavailableStorageToEdit' | i18next }}.
      <a
        class="d-block"
        target="_blank"
        [helpLink]="'https://kb.msp360.com/kb00285'"
        [kbMode]="true"
        >{{ 'shared:buttons.learnMore' | i18next }}</a
      >
    </ng-template>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      *ngIf="!deprecatedStorageTypes.includes(storageAccount.storageType)"
      [type]="'primary'"
      [attr.data-e2e]="'save-btn'"
      [loading]="innerLoading && !hasCriticalError"
      [disabled]="hasCriticalError || destination?.isReadOnly"
      (click)="onActionButtonClick()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>

    <mbs-button
      [type]="'secondary'"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
